import React, { useState, useEffect } from "react";
import GooglePayButton from '@google-pay/button-react';
import SmallScreenView from "../../components/smallscreen";
import { Hidden } from "react-awesome-styled-grid";
import { AmountDivideByHundred } from "../../helper";
import {
  FlexContainer,
  H1Text,
} from "../../design";
import { API } from "../../api";
import PaymentError from "../paymenterror";

type Props = {
  headerText: string,
  payment: Object;
  gpaySecretValues: Object;
  chargeByGooglePay: Function;
  errorMsg: String,
  errorHeader: String,
  gpayError: String,
  splitUpPayload: Object,
};

const GooglePay = (props: Props) => {
  const { headerText, payment, chargeByGooglePay, gpayError, errorMsg, errorHeader, gpaySecretValues, splitUpPayload } = props;
  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState({});

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const getPaymentSplitUp = async () => {
    try {
      const { data: { entity } } = await API.post(`transaction-fee/split-up`, splitUpPayload);
      setPaymentInfo(entity);
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    getPaymentSplitUp();
  }, []);

  return (
    <>
      <H1Text
        className="px-4 px-md-4 mb-0"
      >
        <SmallScreenView>
          {"Pay With Google pay"}
        </SmallScreenView>
        <Hidden sm xs>
          {headerText || "Pay With Google pay"}
        </Hidden>
      </H1Text>
      <FlexContainer
        flexDirection="column"
      >
        <div className="px-1 px-md-4">
          <div class="mt-4">
            <table class="table table-bordered mt-4">
              <tbody>
                {
                  paymentInfo?.amount ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Amount</th>
                      <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.amount)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.coupleDiscountAmount ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Couple Discount</th>
                      <td>{payment?.account?.currency?.prefix}( {AmountDivideByHundred(paymentInfo?.coupleDiscountAmount)})</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.deliveryFee ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Delivery Fee</th>
                      <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.deliveryFee)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.discountedAmount ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Discount</th>
                      <td>{payment?.account?.currency?.prefix} ({AmountDivideByHundred(paymentInfo?.discountedAmount)})</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.itemDiscount ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Item Discount</th>
                      <td>{payment?.account?.currency?.prefix} ({AmountDivideByHundred(paymentInfo?.itemDiscount)})</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.net ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Net</th>
                      <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.net)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.orderDiscount ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Order Discount</th>
                      <td>{payment?.account?.currency?.prefix} ({AmountDivideByHundred(paymentInfo?.orderDiscount)})</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.serviceFee ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Service Fee</th>
                      <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.serviceFee)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.serviceFeePercentage ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Service %</th>
                      <td>% {AmountDivideByHundred(paymentInfo?.serviceFeePercentage)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.subTotal ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Sub Total</th>
                      <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.subTotal)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.subTotalAfterDiscount ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Sub Total After Discount</th>
                      <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.subTotalAfterDiscount)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.surcharge ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Surcharge</th>
                      <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.surcharge)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.tax ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Tax</th>
                      <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.tax)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.tip ? (
                    <tr style={{ borderBottom: 'hidden' }}>
                      <th scope="row">Tip</th>
                      <td>{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.tip)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
                {
                  paymentInfo?.totalPayable ? (
                    <tr style={{ background: '#F7F7F7' }}>
                      <th scope="row">Total Payable</th>
                      <td class="font-weight-bold">{payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.totalPayable)}</td>
                    </tr>
                  ) : (
                    <></>
                  )
                }
              </tbody>
            </table>
          </div>
        </div>
        <div className="px-4 mt-3">
          {
            paymentInfo?.surcharge ? (
              <div style={{ fontSize: "12px", color: "gray" }}>
                * {payment?.account?.currency?.prefix} {AmountDivideByHundred(paymentInfo?.surcharge)} fee applied (typically for credit cards)
              </div>
            ) : null
          }
        </div>
        <div className="px-4 px-md-4 mt-4 mb-4 w-100">
          <div className="row m-0">
            {
              gpaySecretValues ? (
                <GooglePayButton
                  environment={gpaySecretValues && gpaySecretValues.environment}
                  buttonColor="default"
                  buttonType="pay"
                  buttonRadius="4"
                  buttonLocale="en"
                  paymentRequest={{
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [
                      {
                        type: gpaySecretValues && gpaySecretValues.paymentType,
                        parameters: {
                          allowedAuthMethods: gpaySecretValues && gpaySecretValues.allowedAuthMethods,
                          allowedCardNetworks: gpaySecretValues && gpaySecretValues.allowedCardNetworks,
                          billingAddressRequired: true,
                          billingAddressParameters: { format: "FULL", phoneNumberRequired: true }
                        },
                        tokenizationSpecification: {
                          type: gpaySecretValues && gpaySecretValues.acquirerType,
                          parameters: {
                            gateway: gpaySecretValues && gpaySecretValues.gateway,
                            gatewayMerchantId: gpaySecretValues && gpaySecretValues.gatewayMerchantId
                          }
                        }
                      }
                    ],
                    merchantInfo: {
                      merchantId: gpaySecretValues && gpaySecretValues.googlePayMerchantId,
                      merchantName: gpaySecretValues && gpaySecretValues.googlePayMerchantName
                    },
                    transactionInfo: {
                      countryCode: payment.currency.countryAlpha2,
                      currencyCode: payment.currency.name,
                      totalPriceStatus: 'FINAL',
                      totalPrice: AmountDivideByHundred(paymentInfo?.totalPayable),
                      // totalPrice: payment.tip ? AmountDivideByHundred(payment.amount + payment.tip) : AmountDivideByHundred(payment.amount),
                      totalPriceLabel: 'Total'
                    },
                    emailRequired: true,
                    shippingAddressRequired: true
                  }}
                  onLoadPaymentData={paymentRequest => {
                    chargeByGooglePay(paymentRequest);
                  }}
                />

              ) : (
                <GooglePayButton
                  buttonColor="default"
                  buttonType="pay"
                  environment="TEST"
                  buttonRadius="4"
                  buttonLocale="en"
                  paymentRequest={{
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [
                      {
                        type: 'CARD',
                        parameters: {
                          allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                          allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"],
                          billingAddressRequired: true,
                          billingAddressParameters: { format: "FULL", phoneNumberRequired: true }
                        },
                        tokenizationSpecification: {
                          type: 'PAYMENT_GATEWAY',
                          parameters: {
                            gateway: 'cardconnect',
                            gatewayMerchantId: '820000003044'
                          }
                        }
                      }
                    ],
                    merchantInfo: {
                      merchantId: "820000003044",
                      merchantName: "Demo Merchant"
                    },
                    transactionInfo: {
                      countryCode: payment.currency.countryAlpha2,
                      currencyCode: payment.currency.name,
                      totalPriceStatus: 'FINAL',
                      totalPrice: AmountDivideByHundred(payment.amount),
                      totalPriceLabel: 'Total'
                    },
                    emailRequired: true,
                    shippingAddressRequired: true
                  }}
                />
              )
            }
          </div>
        </div>
        <div className="px-1 px-md-2">
          {/* {isShowErrorMessage
            ? (<PaymentError header={errorHeader} message={errorMsg} />)
            : gpayError
              ? (<PaymentError header={errorHeader} message={gpayError} />)
              : ''} */}
          {gpayError && (<PaymentError header={errorHeader} message={gpayError} />)}
        </div>
      </FlexContainer>
    </>
  )
}

export default GooglePay;